(function(){
  if (window.__arUI) return; window.__arUI = 1;
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-ar-dir]'); if (!b) return;
    var root = b.closest('[data-ar-rail]'); if (!root) return;
    var t = root.querySelector('[data-ar-track]'); if (!t) return;
    var d = b.getAttribute('data-ar-dir') === 'prev' ? -1 : 1;
    t.scrollBy({ left: d * t.clientWidth * 0.85, behavior: 'smooth' });
  });
  function sync(){
    document.querySelectorAll('[data-ar-rail]').forEach(function(r){
      var t = r.querySelector('[data-ar-track]'), a = r.querySelector('.ar-arrows');
      if (t && a) a.style.visibility = t.scrollWidth > t.clientWidth + 4 ? 'visible' : 'hidden';
    });
  }
  if (document.readyState !== 'loading') sync(); else document.addEventListener('DOMContentLoaded', sync);
  window.addEventListener('load', sync); window.addEventListener('resize', sync);
})();
(function(){
  if (window.__arHero) return; window.__arHero = 1;
  function init(root){
    if (root.__arInit) return; root.__arInit = 1;
    var track = root.querySelector('[data-ar-hero-track]'), dotsWrap = root.querySelector('[data-ar-hero-dots]');
    if (!track) return;
    var slides = [].slice.call(track.children), n = slides.length, idx = 0, timer = null;
    var clone = null; if (n > 1) { clone = slides[0].cloneNode(true); clone.setAttribute('aria-hidden','true'); clone.tabIndex = -1; track.appendChild(clone); }
    function jump0(){ track.style.scrollBehavior='auto'; track.style.scrollSnapType='none'; track.scrollLeft = 0; requestAnimationFrame(function(){ track.style.scrollSnapType=''; track.style.scrollBehavior=''; }); mark(0); }
    var ms = parseInt(root.getAttribute('data-interval'), 10) || 5000;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var dots = slides.map(function(_, i){
      var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Slide ' + (i + 1));
      b.addEventListener('click', function(){ go(i); restart(); }); if (dotsWrap) dotsWrap.appendChild(b); return b;
    });
    if (n < 2 && dotsWrap) dotsWrap.style.display = 'none';
    function mark(i){ idx = i; slides.forEach(function(s, j){ s.classList.toggle('is-active', j === i); }); dots.forEach(function(d, j){ d.classList.toggle('is-active', j === i); }); }
    function go(i){ if (clone && i === n) { track.scrollTo({ left: clone.offsetLeft - track.offsetLeft, behavior: 'smooth' }); mark(0); return; } i = (i + n) % n; track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' }); mark(i); }
    function start(){ if (reduce || n < 2) return; stop(); timer = setInterval(function(){ go(idx + 1); }, ms); }
    function stop(){ if (timer) { clearInterval(timer); timer = null; } }
    function restart(){ stop(); start(); }
    var st; track.addEventListener('scroll', function(){ clearTimeout(st); st = setTimeout(function(){ var i = Math.round(track.scrollLeft / track.clientWidth); if (clone && i >= n) { jump0(); return; } if (i !== idx) mark(i); }, 80); });
    root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', start);
    track.addEventListener('touchstart', stop, { passive: true }); track.addEventListener('touchend', restart, { passive: true });
    document.addEventListener('visibilitychange', function(){ document.hidden ? stop() : start(); });
    mark(0); start();
  }
  function all(){ document.querySelectorAll('[data-ar-hero]').forEach(init); }
  if (document.readyState !== 'loading') all(); else document.addEventListener('DOMContentLoaded', all);
  document.addEventListener('shopify:section:load', all);
})();
(function(){
  if (window.__arMotion) return; window.__arMotion = 1;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* videos: play only while on screen (saves battery and keeps scrolling smooth), retry play on iOS */
  function vids(){
    if (!('IntersectionObserver' in window)) return;
    function tryPlay(v){ v.muted = true; v.defaultMuted = true; if (v.readyState < 2) { v.preload = 'auto'; v.addEventListener('canplay', function(){ var q = v.play(); if (q && q.catch) q.catch(function(){}); }, { once: true }); if (v.networkState === 0 || v.readyState === 0) { try { v.load(); } catch(e){} } } var pr = v.play(); if (pr && pr.catch) pr.catch(function(){ setTimeout(function(){ var q = v.play(); if (q && q.catch) q.catch(function(){}); }, 600); }); }
    var vio = new IntersectionObserver(function(es){ es.forEach(function(e){ var v = e.target; if (e.isIntersecting) { tryPlay(v); } else if (!v.paused) { v.pause(); } }); }, { threshold: 0.1 });
    document.querySelectorAll('video:not([controls])').forEach(function(v){ if (v.__arV) return; v.__arV = 1; v.muted = true; v.setAttribute('playsinline', ''); vio.observe(v); });
    var kick = function(){ document.querySelectorAll('video:not([controls])').forEach(function(v){ var r = v.getBoundingClientRect(); if (r.top < innerHeight && r.bottom > 0 && v.paused) tryPlay(v); }); };
    document.addEventListener('touchstart', kick, { passive: true });
    document.addEventListener('click', kick);
    document.addEventListener('scroll', function(){ clearTimeout(kick.t); kick.t = setTimeout(kick, 250); }, { passive: true, capture: true });
  }
  if (document.readyState !== 'loading') vids(); else document.addEventListener('DOMContentLoaded', vids);
  window.addEventListener('load', vids);
  /* scroll reveal only on desktop mice: phones scroll freely with no extra work */
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 900px)').matches;
  if (reduce || !fine) return;
  var SEL = ['.ar-sec .ar-head','.ar-howto__step','.ar-rv__sum','.ar-rv__row','.ar-trow__item','.ar-cmp__card','.ar-faq__card','.ar-story__copy','.ar-finds__tile','.ar-tix__ticket','[class^="ai-action-"][class$="__card"]'].join(',');
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function(es){
    es.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -4% 0px', threshold: 0 }) : null;
  function prep(scope){
    if (!io) return;
    var vh = window.innerHeight;
    (scope || document).querySelectorAll(SEL).forEach(function(el){
      if (el.__arR) return; el.__arR = 1;
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.92) return; /* already visible: never hide it */
      var sib = el.parentElement ? [].indexOf.call(el.parentElement.children, el) : 0;
      el.style.setProperty('--ar-d', Math.min(sib % 6, 5) * 0.07 + 's');
      el.classList.add('ar-reveal'); io.observe(el);
    });
  }
  function imgs(){
    document.querySelectorAll('.ar-root img, .ar-col img').forEach(function(img){
      if (img.__arI) return; img.__arI = 1;
      if (img.complete && img.naturalWidth) return;
      img.classList.add('ar-img-wait');
      var done = function(){ img.classList.remove('ar-img-wait'); };
      img.addEventListener('load', done, { once: true }); img.addEventListener('error', done, { once: true });
      setTimeout(done, 4000);
    });
  }
  var tk = 0;
  function sweep(){ tk = 0; var vh = window.innerHeight; document.querySelectorAll('.ar-reveal:not(.is-in)').forEach(function(el){ var r = el.getBoundingClientRect(); if (r.top < vh * 0.97 && r.bottom > 0) { el.classList.add('is-in'); if (io) io.unobserve(el); } }); }
  window.addEventListener('scroll', function(){ if (!tk) tk = setTimeout(sweep, 120); }, { passive: true, capture: true });
  function init(){ prep(); setTimeout(sweep, 600); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function(e){ prep(e.target); });
})();

(function(){document.querySelectorAll('.ar-road').forEach(function(r,i){r.style.setProperty('--ar-cur-d',(-(i*1.1)%2.4).toFixed(2)+'s');});})();

(function(){
  var bar=document.querySelector('.sticky-add-to-cart'); if(!bar||!('IntersectionObserver' in window)) return;
  var f=document.querySelector('footer, .ar-footer, #shopify-section-footer'); if(!f) return;
  new IntersectionObserver(function(es){
    var on=es[0].isIntersecting;
    bar.classList.toggle('ar-near-footer',on); document.body.classList.toggle('ar-near-footer',on);
  },{rootMargin:'0px 0px -80px 0px'}).observe(f);
})();

/* smooth media: async decode, soft placeholder, fade in when loaded */
(function(){
  function prep(img){
    if(img.__arm) return; img.__arm=1; img.decoding='async';
    if(img.complete && img.naturalWidth) return;
    if(img.closest('.ar-hero2, .ar-mq')) return;
    img.style.opacity='0'; img.style.transition='opacity .35s ease';
    var show=function(){img.style.opacity='';};
    img.addEventListener('load',show,{once:true}); img.addEventListener('error',show,{once:true});
  }
  function run(root){(root||document).querySelectorAll('img').forEach(prep);}
  if(document.readyState!=='loading') run(); else document.addEventListener('DOMContentLoaded',function(){run()});
  new MutationObserver(function(m){m.forEach(function(r){r.addedNodes.forEach(function(n){if(n.nodeType===1){if(n.tagName==='IMG')prep(n);else if(n.querySelectorAll)run(n);}})})}).observe(document.documentElement,{childList:true,subtree:true});
})();
